import React, { useCallback } from 'react';

import config from 'configs/app';
import useAddChainClickV2 from 'lib/web3/useAddChainClickV2';
import { Button } from 'toolkit/chakra/button';

const feature = config.features.web3Wallet;

const NetworkAddToWallet = () => {
  const handleAddChain = useAddChainClickV2();

  if (!config.chain.rpcUrls.length || !feature.isEnabled) return null;

  const handleClick = useCallback(() => {
    handleAddChain();
  }, [ handleAddChain ]);

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={ handleClick }
      className="footer-add-network"
    >
      Add { config.chain.name }
    </Button>
  );
};

export default React.memo(NetworkAddToWallet);
